import type { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { requestJBPActualsAndTargetsSettings } from 'legacy/lut/components/widgets/public/partner360/services/requestJBPActualsAndTargetsSettings'
import { useEffect, useState } from 'react'

export const useSobAvailabilitySettings = ({
  pid,
  currentFiscalYear,
  offering,
}: {
  pid: string
  currentFiscalYear: number
  offering: string
}) => {
  const [sobAvailabilitySettings, setSobAvailabilitySettings] = useState<
    IFormActualsTargetsSettings[]
  >([])
  const [isSobAvailabilitySettingsLoaded, setIsSobAvailabilitySettingsLoaded] = useState(false)

  useEffect(() => {
    let isActual = true

    setSobAvailabilitySettings([])
    setIsSobAvailabilitySettingsLoaded(false)

    if (!pid || !currentFiscalYear || !offering) {
      setIsSobAvailabilitySettingsLoaded(true)

      return () => {
        isActual = false
      }
    }

    const fetchSobAvailabilitySettings = async () => {
      try {
        const settingsResponse =
          await requestJBPActualsAndTargetsSettings<IFormActualsTargetsSettings>(
            pid,
            currentFiscalYear,
            offering
          )

        if (!isActual) {
          return
        }

        setSobAvailabilitySettings(settingsResponse?.Rows ?? [])
      } catch {
        if (isActual) {
          setSobAvailabilitySettings([])
        }
      } finally {
        if (isActual) {
          setIsSobAvailabilitySettingsLoaded(true)
        }
      }
    }

    void fetchSobAvailabilitySettings()

    return () => {
      isActual = false
    }
  }, [currentFiscalYear, offering, pid])

  return {
    sobAvailabilitySettings,
    isSobAvailabilitySettingsLoaded,
  }
}
